module.exports = __webpack_public_path__ + "static/media/landing_mobile.ca1d5332.jpg";